import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

const AddressManagement = () => {
  const [formValues, setFormValues] = useState({
    tradeName: '',
    entityType: '',
    phoneNumber: '',
    legalName: '',
    emailId: '',
    state: '',
    supplierAddress1: '',
    supplierAddress2: '',
    supplierLocation: '',
    pinCode: '',
    supplierGstin: ''
  });

  const [suppliers, setSuppliers] = useState([
    {
      id: 1,
      supplier_child_address_one: 'XXX company',
      supplier_child_address_two: 'Coimbatore',
      supplier_child_location: '641050',
      supplier_child_state: 'xx xx xxx',
      emaisupplier_child_pincodelId: 'xxx xxx',
      // state: 'Tamilnadu',
    }
  ]);

  const entityTypes = [
    'Private Limited',
    'Public Limited',
    'Partnership',
    'Proprietorship',
    'LLP'
  ];

  const states = [
    'Andhra Pradesh',
    'Tamil Nadu',
    'Karnataka',
    'Kerala',
    'Maharashtra',
    'Gujarat',
    'Delhi',
    'Uttar Pradesh',
    'West Bengal'
  ];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create new supplier object from form values
    const newSupplier = {
      id: suppliers.length + 1,
      tradeName: formValues.tradeName,
      entityType: formValues.entityType,
      legalName: formValues.legalName,
      phoneNumber: formValues.phoneNumber,
      emailId: formValues.emailId,
      address: formValues.supplierAddress1,
      location: formValues.supplierLocation,
      gstin: formValues.supplierGstin,
      state: formValues.state
    };

    // Add to suppliers array
    setSuppliers([...suppliers, newSupplier]);

    // Reset form
    setFormValues({
      legalName: '',
      location: '',
      pincode: '',
      address1: '',
      address2: '',
      state: '',
    });
  };

  const handleCancel = () => {
    setFormValues({
      legalName: '',
      location: '',
      pincode: '',
      address1: '',
      address2: '',
      state: '',
    });
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 1, mb: 1 }}>
      {/* <Typography variant="h5" component="h1" fontWeight="500" gutterBottom>
        Supplier Information Management
      </Typography> */}

      <Paper
        elevation={1}
        sx={{
          p: 3,
          mt: 0,
          borderRadius: '8px',
          backgroundColor: '#fff'
        }}
      >

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Legal Name"
                name="tradName"
                value={formValues.legalName}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Location"
                name="location"
                value={formValues.location}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Pincode"
                name="pincode"
                value={formValues.pincode}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              />
            </Grid>


            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Address 1"
                name="address1"
                value={formValues.address1}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              />
            </Grid>


            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Address 2"
                name="address2"
                value={formValues.address2}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              />
            </Grid>


            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="State"
                name="state"
                select
                value={formValues.state}
                onChange={handleChange}
                variant="outlined"
                size="small"
                margin="normal"
              >
                {states.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              onClick={handleCancel}
              sx={{
                mr: 1,
                color: '#757575',
                borderColor: '#757575',
                '&:hover': {
                  borderColor: '#757575',
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
              variant="outlined"
            >
              CANCEL
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0'
                }
              }}
            >
              SUBMIT
            </Button>
          </Box>
        </form>
      </Paper>

      <Paper elevation={1} sx={{ mt: 4, borderRadius: '8px' }}>
        <Typography variant="h6" component="h2" fontWeight="500" sx={{ px: 3, pt: 3, pb: 2 }}>
          Submitted Entries
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                <TableCell>Primary Address</TableCell>
                <TableCell>Secondary Address</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>State</TableCell>
                <TableCell>Pincode</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {suppliers.map((supplier) => (
                <TableRow key={supplier.id} hover>
                  <TableCell>{supplier.supplier_child_address_one}</TableCell>
                  <TableCell>{supplier.supplier_child_address_two}</TableCell>
                  <TableCell>{supplier.supplier_child_location}</TableCell>
                  <TableCell>{supplier.supplier_child_state}</TableCell>
                  <TableCell>{supplier.emaisupplier_child_pincodelId}</TableCell>
                  <IconButton size="small">
                    <EditIcon fontSize="small"  style={{display:'flex', justifyContent: 'center'}}/>
                  </IconButton>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
};

export default AddressManagement;